export const guestPickerValidationSelectors = {
  getTriggerValidation: (state) => state.guestPickerValidation?.triggerValidation || false,
};
